import { render } from "./VensysProductionComponent.vue?vue&type=template&id=6d00a78f&scoped=true&ts=true"
import script from "./VensysProductionComponent.vue?vue&type=script&lang=ts"
export * from "./VensysProductionComponent.vue?vue&type=script&lang=ts"

import "./VensysProductionComponent.vue?vue&type=style&index=0&id=6d00a78f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d00a78f"]])

export default __exports__